// src/FullPageChat.js

import React, { Component } from "react";
import api from './api';
import './Doctors.css';

class Chat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      messages: [],
      input: "",
      isLoading: false
    };

    this.handleSend = this.handleSend.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.sendRequest = this.sendRequest.bind(this);
  }

  handleInput(e) {
    this.setState({ input: e.target.value });
  }

  handleSend() {
    const text = this.state.input.trim();
    if (!text) return;

    const msgs = [...this.state.messages, { role: "user", text }];
    this.setState({ messages: msgs, input: "", isLoading: true });
    this.sendRequest(text);
  }

  sendRequest(text) {
    /*
    this.setState({ isLoading: true });

    api.post(`${process.env.REACT_APP_URL}/chat/`, { message: text })
      .then((resp) => {
        this.setState({ isLoading: false });

        const reply = resp.data?.answer || "Error reading answer";
        const msgs = [...this.state.messages, { role: "assistant", text: reply }];

        this.setState({ messages: msgs });
      })
      .catch((err) => {
        console.error("API error:", err);
        this.setState({ isLoading: false });

        const msgs = [...this.state.messages, {
          role: "assistant",
          text: "❌ Network error. Please try again."
        }];

        this.setState({ messages: msgs });
      });
      */
  }

  renderBotMessage(text) {
    if (!text) return "";

    // Split answer into sections by double newline
    const chunks = text.split(/\n\n+/);

    return chunks.map((chunk, i) => {
      // Extract a title if markdown-style heading exists
      const lines = chunk.split("\n").filter(Boolean);
      let title = "";
      let body = chunk;

      if (lines[0].startsWith("**") && lines[0].endsWith("**")) {
        title = lines[0].replace(/\*\*/g, "");
        body = lines.slice(1).join("\n");
      }

      // Convert **bold** → <strong>
      body = body.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");

      // Convert tables
      if (body.includes("|")) {
        const tableLines = body.split("\n").filter(Boolean);
        let tableHtml = "<table>";
        tableLines.forEach((line, idx) => {
          const cells = line.split("|").map(c => c.trim()).filter(Boolean);
          if (!cells.length) return;
          tableHtml += "<tr>";
          cells.forEach(cell => {
            const tag = idx === 0 ? "th" : "td";
            tableHtml += `<${tag}>${cell}</${tag}>`;
          });
          tableHtml += "</tr>";
        });
        tableHtml += "</table>";
        body = tableHtml;
      }

      return (
        <div key={i} style={styles.card}>
          {title && <div style={styles.cardTitle}>{title}</div>}
          <div dangerouslySetInnerHTML={{ __html: body }} style={styles.cardBody} />
        </div>
      );
    });
  }

  render() {
    if (!this.props.isOpen) return null;

    return (
      <div style={styles.overlay}>
        <div style={styles.header}>
          <span>Chat Assistant</span>
          <button onClick={this.props.onClose} style={styles.closeBtn}>×</button>
        </div>

        <div style={styles.chatArea}>
          {this.state.messages.map((m, i) => (
            <div
              key={i}
              style={m.role === "user" ? styles.userMsg : styles.botMsg}
            >
              {m.role === "user" ? (
                m.text
              ) : (
                this.renderBotMessage(m.text)
              )}
            </div>
          ))}
          {this.state.isLoading && (
            <div style={styles.botMsg}>
              <div style={{ whiteSpace: "pre-wrap" }}>Typing…</div>
            </div>
          )}
        </div>

        <div style={styles.inputBar}>
          <input
            style={styles.input}
            value={this.state.input}
            onChange={this.handleInput}
            placeholder="Type a message..."
          />
          <button style={styles.sendBtn} onClick={this.handleSend}>Send</button>
        </div>
      </div>
    );
  }
}

export default Chat;

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "#f3f3f3",
    zIndex: 9998,
    display: "flex",
    flexDirection: "column"
  },
  header: {
    padding: "15px",
    fontSize: "18px",
    background: "#0078ff",
    color: "#fff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  closeBtn: {
    background: "transparent",
    border: "none",
    color: "#fff",
    fontSize: "26px",
    cursor: "pointer"
  },
  chatArea: {
    flex: 1,
    overflowY: "scroll",
    padding: "10px"
  },
  userMsg: {
    background: "#0078ff",
    color: "#fff",
    padding: "10px",
    borderRadius: "10px",
    margin: "5px 0",
    alignSelf: "flex-end",
    maxWidth: "70%"
  },
  botMsg: {
    background: "transparent",
    padding: "5px 0",
    margin: "5px 0",
    alignSelf: "flex-start",
    maxWidth: "100%"
  },
  card: {
    background: "#ffffff",
    padding: "12px",
    marginBottom: "10px",
    borderRadius: "12px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
    whiteSpace: "pre-wrap"
  },
  cardTitle: {
    fontWeight: "bold",
    background: "#e0f0ff",
    padding: "5px 8px",
    borderRadius: "8px",
    marginBottom: "6px",
    color: "#0078ff"
  },
  cardBody: {
    fontSize: "15px",
    lineHeight: "1.5"
  },
  inputBar: {
    padding: "10px",
    display: "flex",
    borderTop: "1px solid #ccc"
  },
  input: {
    flex: 1,
    padding: "10px",
    fontSize: "16px",
    border: "1px solid #ccc",
    borderRadius: "5px"
  },
  sendBtn: {
    marginLeft: "10px",
    padding: "10px 15px",
    fontSize: "16px",
    background: "#0078ff",
    border: "none",
    color: "#fff",
    borderRadius: "5px",
    cursor: "pointer"
  }
};
